module.exports = __webpack_public_path__ + "static/alertDesignPattern-2965a25e3d7d483dcf8809f641abadc2.png";